import { useState } from "react"

import { TextField } from "@minuthq/meatball-ui-react"

import { MDialog } from "src/ui/Dialog/MDialog"

const FORM_ID = "paradise-mutate-graph-view-dialog-form"

export function ParadiseMutateGraphViewDialog({
  open,
  onClose,
  title,
  onSave,
  initialName,
}: {
  open: boolean
  onClose: () => void
  title: string
  onSave: (name: string) => void
  initialName?: string
}) {
  const [name, setName] = useState(initialName ?? "")

  function closeDialog() {
    setName("")
    onClose()
  }

  return (
    <MDialog open={open} onClose={closeDialog} title={title} formId={FORM_ID}>
      <form
        id={FORM_ID}
        onSubmit={(e) => {
          e.preventDefault()
          onSave(name)
          closeDialog()
        }}
      >
        <TextField
          value={name}
          onChange={setName}
          label="Name"
          name="name"
          required
        />
      </form>
    </MDialog>
  )
}
